import makeStyles from "@mui/styles/makeStyles";
import { colors } from "@zapalacorp/tokens";

const styles = makeStyles(() => ({
  chipBoxProject: {
    display: "inline",
    flexWrap: "wrap",
    textOverflow: "ellipsis",
    height: 40,
    alignItems: "center",
  },

  chipBranch: {
    backgroundColor: colors.blue50,
    color: colors.blue500,
    margin: "2px",
  },
}));

export default styles;
